import { PROJECTTYPE_ENUM} from '@/utils/enums'
import { warning } from '@/assets/js/common.js'

const areaMixins = {
  data() {
    return {
      showControlModeRadio: '1', //自动化详情里面区分
      controlModeRadio: '1',// 弹窗里面区分总控和分控
      temparealist: [], // 区域选择列表-数据
      tempareacheckedarea: [], // 已选的区域-数据
      tempareaactionPannel: false, // 区域的批处理选择页-显示
      tempareaactionlist: [], // 区域选中的批处理能力-数据
      dialogAreaSelect: false, // 区域的选择页-显示
      AgricultureActionList:[
        ...Array.from({length :4}).flatMap((_, i)=>[
           {
            IsShow: true,
            ischeck: false,
            MsgType: '0x03110000',
            ShowMode: -1,
            Desc: this.$t('sceneCard.lightSwitch'),
            ChannelId: i + 1,
            ControlName: `${this.$t('scene.partialControl')}${i + 1}`,
            Values: [
              {
                KeyId: 1,
                ValueType: 'UIControl_Switch',
                Name: this.$t('sceneCard.lightSwitch'),
                DefaultValue: 1,
                Min: 0,
                Max: 1,
                EnumValue: [
                  { Name: this.$t('sceneCard.openLight'), Value: 1 },
                  { Name: this.$t('sceneCard.closeLight'), Value: 0 }
                ],
                IsShow: true,
                Type: '0x0207'
              }
            ],
            ControlType: 0
           },
           {
              IsShow: true,
              ischeck: false,
              MsgType: '0x03130000',
              ShowMode: -1,
              Desc: this.$t('sceneCard.light'),
              ChannelId: i + 1,
              Values: [
                {
                  KeyId: 1,
                  ValueType: 'UIControl_Bright',
                  Name: this.$t('sceneCard.light'),
                  DefaultValue: 0,
                  Min: this.$store.state.staticConfig.AbilityConfig.DefaultValue.Ifttt['0x03130000'].Value.minValue,
                  Max: 255,
                  EnumValue: [],
                  IsShow: true,
                  Type: '0x0300'
                }
              ],
              ControlType: 4
           }
        ])
      ],
      areaActionTempList: {
        AreaNames: [],
        AreaIds: [],
        ActionList: [        
          {
            IsShow: true,
            ischeck: false,
            MsgType: '0x03130000',
            ShowMode: -1,
            Desc: this.$t('sceneCard.light'),
            Values: [
              {
                KeyId: 1,
                ValueType: 'UIControl_Bright',
                Name: this.$t('sceneCard.light'),
                DefaultValue: 0,
                Min: this.$store.state.staticConfig.AbilityConfig.DefaultValue.Ifttt['0x03130000'].Value.minValue,
                Max: 255,
                EnumValue: [],
                IsShow: true,
                Type: '0x0300'
              }
            ],
            ControlType: 4
          },
          // 分级调光
          {
            IsShow: true,
            ischeck: false,
            MsgType: '0x03840000',
            ShowMode: -1,
            Desc: this.$t('sceneCard.dim'),
            Values: [
              {
                KeyId: 1,
                ValueType: 'UIControl_UpAndDown',
                Name: this.$t('sceneCard.dim'),
                DefaultValue: 1,
                Min: 1,
                Max: 0,
                EnumValue: [
                  { Name: this.$t('sceneCard.dimmingDown'), Value: 1 },
                  { Name: this.$t('sceneCard.dimmingUp'), Value: 0 },
                ],
                IsShow: true,
                Type: null
              }
            ],
            ControlType: 5
          },
          {
            IsShow: true,
            ischeck: false,
            MsgType: '0x031B0000',
            ShowMode: -1,
            Desc: this.$t('sceneCard.colorWarm'),
            Values: [
              {
                KeyId: 1,
                ValueType: 'UIControl_ColorTemperature',
                Name: this.$t('sceneCard.colorWarm'),
                DefaultValue: 4000,
                cctValue: 4000,
                Min: this.$store.state.colorTemperatureRange.Min,
                Max: this.$store.state.colorTemperatureRange.Max,
                EnumValue: [],
                IsShow: true,
                Type: '0x0400'
              }
            ],
            ControlType: 3
          },
          // 分级调色温
          {
            IsShow: true,
            ischeck: false,
            MsgType: '0x03880000',
            ShowMode: -1,
            Desc: this.$t('sceneCard.cct'),
            Values: [
              {
                KeyId: 1,
                ValueType: 'UIControl_CCT',
                Name: this.$t('sceneCard.cct'),
                DefaultValue: 1,
                Min: 1,
                Max: 0,
                EnumValue: [
                  { Name: this.$t('sceneCard.cctWarm'), Value: 1 },
                  { Name: this.$t('sceneCard.cctCold'), Value: 0 }
                ],
                IsShow: true,
                Type: null
              }
            ],
            ControlType: 8
          },
          {
            IsShow: true,
            ischeck: false,
            MsgType: '',
            ShowMode: -1,
            Desc: this.$t('sceneCard.color'),
            Values: [
              {
                KeyId: 1,
                ValueType: 'UIControl_Color',
                Name: this.$t('sceneCard.color'),
                DefaultValue: '#0',
                Min: '#0',
                IsShow: true,
                Type: null
              }
            ],
            ControlType: 2
          },
        ]
      },
      oppleActionList: [
        {
          IsShow: true,
          ischeck: false,
          MsgType: '0x03110000',
          ShowMode: -1,
          Desc: this.$t('sceneCard.lightSwitch'),
          Values: [
            {
              KeyId: 1,
              ValueType: 'UIControl_Switch',
              Name: this.$t('sceneCard.lightSwitch'),
              DefaultValue: 1,
              Min: 0,
              Max: 1,
              EnumValue: [
                { Name: this.$t('sceneCard.openLight'), Value: 1 },
                { Name: this.$t('sceneCard.closeLight'), Value: 0 }
              ],
              IsShow: true,
              Type: '0x0207'
            }
          ],
          ControlType: 0
        },
      ],
    }
  },

  computed: {
    filteredAreaControlActionList() {
      const defaultActionList = this.areaActionTempList.ActionList;
      let result = [];

      // 农业项目
      if (this.$store.state.projectinfor.ProjectType === PROJECTTYPE_ENUM.Agriculture) {
        if (this.controlModeRadio === '2') {
          result = this.isExistGSDevice
            ? [...this.gelansibeiActionList, ...this.AgricultureActionList]
            : [...this.AgricultureActionList];
        } else if (this.controlModeRadio === '1') {
          result = this.isExistGSDevice
            ? [...this.gelansibeiActionList, ...defaultActionList]
            : [...this.oppleActionList, ...defaultActionList];
        }
      } else {
        // 其他项目（保留原有逻辑）
        result = this.isExistGSDevice
          ? [...this.gelansibeiActionList, ...defaultActionList]
          : [...this.oppleActionList, ...defaultActionList];
      }

      return result
    }
  },

  methods: {
    modifyAreaAction(item) {
      this.modifyItem = item;
      this.areaActionTempListDefault();
      
      const actionList = item.ActionList;

      if (Array.isArray(actionList)) {
        const { ProjectType } = this.$store.state.projectinfor;
        const isAgriculture = ProjectType === PROJECTTYPE_ENUM.Agriculture;
        
        // 设置控制模式
        this.controlModeRadio = actionList.some(i => i.ChannelId && i.ChannelId !== 65535) ? '2' : '1';
        
        // 更新选中状态
        this.filteredAreaControlActionList.forEach(action => {
          const match = actionList.find(a => {
            if (isAgriculture && this.controlModeRadio === '2') {
              return a.ControlType === action.ControlType && a.ChannelId === action.ChannelId;
            }
            return a.ControlType === action.ControlType;
          });
          
          action.ischeck = !!match;
          if (match && action.Values?.[0]) {
            action.Values[0].DefaultValue = match.Values?.[0]?.DefaultValue;
          }
        });
      }
      
      // 打开对话框
      this.dialogAreaSelect = true;
      this.temparealist = [];
      this.tempareacheckedarea = [];
      
      setTimeout(() => {
        this.dialogAreaSelect = false;
        this.tempareaactionPannel = true;
      }, 10);
    },

    areaActionTempListDefault () {
      this.areaActionTempList.AreaNames = []
      this.areaActionTempList.AreaIds = []
      this.filteredAreaControlActionList.forEach(param => {
        param.ischeck = false
        param.Values[0].DefaultValue = param.Values[0].cctValue || param.Values[0].Min
      })
    },

    addAreaAction() {
      // 获取选中的动作
      const selectedActions = this.filteredAreaControlActionList
        .filter(p => p.ischeck)
        .map(p => {
          const v = p.Values?.[0] || {};
          return {
            MsgType: p.MsgType,
            ShowMode: -1,
            Desc: p.Desc,
            ischeck: true,
            Values: [{
              KeyId: v.KeyId,
              ValueType: v.ValueType,
              Name: v.Name,
              Min: v.Min,
              Max: p.ControlType === 4 ? 100 : v.Max,
              EnumValue: v.EnumValue,
              IsShow: v.IsShow,
              Type: v.Type,
              DefaultValue: v.DefaultValue
            }],
            ControlType: p.ControlType,
            ControlName: p.ControlName,
            ChannelId: p.ChannelId
          };
        });
      
      if (selectedActions.length === 0) {
        warning(this, this.$t('iftttset.SelecAction'));
        return;
      }
      
      if (this.modifyItem) {
        // 修改模式
        Object.assign(this.modifyItem, {
          ActionList: selectedActions,
          showControlModeRadio: this.controlModeRadio
        });
      } else {
        // 新增模式
        const newActions = this.temparealist
          .map(a => ({
            Gpno: a.id,
            AreaName: a.label,
            ActionType: 6,
            ActionList: [...selectedActions],
            showControlModeRadio: this.controlModeRadio
          }))
          .filter(a => a.ActionList.length > 0);
        
        this.allactionlist.push(...newActions);
      }
      
      this.tempareaactionPannel = false;
      this.areaActionTempListDefault();
    },

    /* 获得选择的区域
     * val 区域id
     */
    getarealist (val) {
      this.temparealist = val
    },
  }
}


export default areaMixins;